module.exports = __webpack_public_path__ + "static/images/trending-up.e5c4b97320527462871febeb8be76ecd.svg";